import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import CurrentUser from './model'

const CurrentUserModule = {
  namespaced : true,
  state      : {
    //- The logged in user
    current_user : new CurrentUser(),

    //- The permissions after logging in
    permissions: {},

    notifications: [],
    handledCasesAreVisible: false
  },
  getters,
  actions,
  mutations
}

export default CurrentUserModule